import { Attachment } from './attachment';

export const ATTACHMENT_REPO_TOKEN = 'ATTACHMENT_REPO';

export interface IAttachmentRepo {
  getAttachment: (attachmentId: string) => Promise<Attachment>;
  listAssetAttachments: (assetId: string) => Promise<Attachment[]>;
}
